<template src="../templates/normal_fcont_126.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import CreativePrint from '../components/CreativePrint'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import AppDownloadiPrint from '../components/AppDownloadiPrint';

import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '126',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,CreativePrint,ReleaseDateForArticle,
    AppDownloadiPrint
  },
  
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['126-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['126-2']}
    ]};
  }
  
};
</script>
<style >
</style>

